import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/technologies/edge-computing/page.tsx");
